/* Copyright Epoq Legal Ltd 2009-2015 */

var Selector = (typeof Selector == "undefined") ? {} : Selector;

Selector.Collection = {};
Selector.Model = {};
Selector.View = {};

$(function(){